import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ErrorButton } from "src/components/Default/LekUI/Button";

import { SelectionBar } from "./SelectionBar";

interface DecksSelectionBarProps {
	selectedCount: number;
	onRemove: () => void;
	onClose: () => void;
	isRemoving: boolean;
}

export const DecksSelectionBar = ({
	selectedCount,
	onRemove,
	onClose,
	isRemoving,
}: DecksSelectionBarProps) => {
	const { t } = useTranslation();

	return (
		<SelectionBar
			selectedCount={selectedCount}
			onClose={onClose}
			actions={
				<ErrorButton
					data-test-id="decks-selection-remove-button"
					onClick={onRemove}
					disabled={isRemoving || selectedCount === 0}
					className="flex items-center gap-8 folder-selection-bar-btn"
				>
					<Trash2 className="icon-small" />
					<span className="folder-selection-bar-text">
						{t("userDecks.removeDecks", "Usuń")}
					</span>
				</ErrorButton>
			}
		/>
	);
};
